import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_DE from "./de/translations.json";
import TRANSLATE_EL from "./el/translations.json";
import TRANSLATE_SV from "./sv/translations.json";
import TRANSLATE_CS from "./cs/translations.json";
import TRANSLATE_HU from "./hu/translations.json";

export const translations = {
  el: { translation: TRANSLATE_EL },
  en: { translation: TRANSLATE_EN },
  de: { translation: TRANSLATE_DE },
  sv: { translation: TRANSLATE_SV },
  cs: { translation: TRANSLATE_CS },
  hu: { translation: TRANSLATE_HU },
};
